import { type SVGProps } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles/VerifyEmail.module.css';

export const VerifyEmail = () => {
  const { t } = useTranslation(['label']);
  return (
    <div className={styles.verifyEmail} data-testid="verify-email">
      <div className={styles.iconContainer}>
        <CheckIcon className={styles.icon} />
      </div>
      <h2 className={styles.title}>{t('CX_AUTH_THANKS_REGISTERING')}</h2>
      <div className={styles.content}>
        <p className={styles.text}>{t('CX_AUTH_CHECK_EMAIL')}</p>
      </div>
    </div>
  );
};

VerifyEmail.displayName = 'VerifyEmail';

function CheckIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} fill="none" height="74" viewBox="0 0 74 74" width="74" xmlns="http://www.w3.org/2000/svg">
      <circle cx="37" cy="37" fill="#00E889" r="37" />
      <path d="M16 39.0682L28.5568 51.625L56.1818 24" stroke="#022E4A" strokeLinecap="round" strokeWidth="4" />
    </svg>
  );
}
